'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { StaticImageData } from 'next/image';
import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_IMG_URI } from '@src/utils/constants.util';
import { cn } from '@src/utils/tailwind';
export const HeroMedia = t0 => {
  const $ = _c(17);
  const {
    src,
    blurDataURL,
    className,
    alt
  } = t0;
  const [extension, setExtension] = useState("");
  let t1;
  if ($[0] !== src) {
    t1 = async () => {
      const response = await fetch(src as string, {
        method: "HEAD"
      });
      setExtension(response.headers.get("content-type") as any);
    };
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getExtension = t1;
  let t2;
  let t3;
  if ($[2] !== getExtension || $[3] !== src) {
    t2 = () => {
      if (!src) {
        return;
      }
      getExtension();
    };
    t3 = [src, getExtension];
    $[2] = getExtension;
    $[3] = src;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (!src) {
    return null;
  }
  if (extension.includes("video") && typeof src === "string") {
    let t4;
    if ($[6] !== className) {
      t4 = cn(className, "h-full", "w-full");
      $[6] = className;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <track kind="captions" />;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== src || $[10] !== t4) {
      t6 = <video className={t4} controls={false} loop={true} src={src} autoPlay={true} playsInline={true} muted={true}>{t5}</video>;
      $[9] = src;
      $[10] = t4;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  const t4 = alt ?? "";
  const t5 = blurDataURL || DEFAULT_IMG_URI;
  let t6;
  if ($[12] !== className || $[13] !== src || $[14] !== t4 || $[15] !== t5) {
    t6 = <Image className={className} alt={t4} src={src} loading="eager" placeholder="blur" blurDataURL={t5} fill={true} />;
    $[12] = className;
    $[13] = src;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};